const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
class SwHeader extends HTMLElement {
connectedCallback() {
this.panel = this.querySelector('.sw-header__panel');
this.scrim = this.querySelector('.sw-header__scrim');
this.menuButtons = [...this.querySelectorAll('[data-sw-menu-toggle]')];
this.catsButton = this.querySelector('[data-sw-cats-toggle]');
this.cats = this.querySelector('.sw-header__cats');
this.count = this.querySelector('[data-sw-cart-count]');
this.autoHide = this.dataset.autoHide !== 'false';
this.lastY = window.scrollY;
this.menuButtons.forEach((button) => button.addEventListener('click', this.toggleMenu));
this.scrim?.addEventListener('click', this.closeMenu);
this.catsButton?.addEventListener('click', this.toggleCats);
this.addEventListener('keydown', this.onKeydown);
window.addEventListener('scroll', this.onScroll, { passive: true });
document.addEventListener('shopify:cart:lines-update', this.onCartUpdate);
window.addEventListener('pageshow', this.onPageShow);
}
disconnectedCallback() {
window.removeEventListener('scroll', this.onScroll);
document.removeEventListener('shopify:cart:lines-update', this.onCartUpdate);
window.removeEventListener('pageshow', this.onPageShow);
clearTimeout(this.showTimer);
clearTimeout(this.closeTimer);
}
get isOpen() {
return this.hasAttribute('data-open');
}
toggleMenu = () => (this.isOpen ? this.closeMenu() : this.openMenu());
openMenu = () => {
clearTimeout(this.closeTimer);
this.removeAttribute('data-closing');
this.removeAttribute('data-hidden');
this.setAttribute('data-open', '');
this.panel.hidden = false;
this.scrim.hidden = false;
this.menuButtons.forEach((button) => button.setAttribute('aria-expanded', 'true'));
};
closeMenu = () => {
if (!this.isOpen || this.hasAttribute('data-closing')) return;
this.setAttribute('data-closing', '');
this.menuButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
this.closeTimer = setTimeout(() => {
this.removeAttribute('data-open');
this.removeAttribute('data-closing');
this.panel.hidden = true;
this.scrim.hidden = true;
}, reducedMotion.matches ? 0 : 120);
};
toggleCats = () => {
const expanded = this.catsButton.getAttribute('aria-expanded') === 'true';
this.catsButton.setAttribute('aria-expanded', String(!expanded));
this.cats.hidden = expanded;
};
onKeydown = (event) => {
if (event.key === 'Escape' && this.isOpen) {
this.closeMenu();
this.menuButtons.find((button) => button.offsetParent)?.focus();
}
};
onScroll = () => {
if (!this.autoHide || this.isOpen) return;
const y = window.scrollY;
if (y > 80 && y > this.lastY) this.setAttribute('data-hidden', '');
else if (y <= 80) this.show();
this.lastY = y;
clearTimeout(this.showTimer);
this.showTimer = setTimeout(this.show, 1000);
};
show = () => {
if (!this.hasAttribute('data-hidden')) return;
this.removeAttribute('data-hidden');
if (reducedMotion.matches) return;
this.querySelectorAll('.sw-shine').forEach((shine) => {
shine.style.animation = 'none';
void shine.offsetWidth;
shine.style.animation = 'sw-shine 1.2s cubic-bezier(.4,0,.2,1) .15s 1 both';
});
};
onCartUpdate = (event) => {
event.promise
?.then(({ cart, detail }) => {
const count = cart?.totalQuantity ?? detail?.itemCount;
if (typeof count === 'number') this.renderCount(count, true);
})
.catch(() => {});
};
onPageShow = (event) => {
if (!event.persisted) return;
fetch(`${window.Shopify?.routes?.root ?? '/'}cart.js`)
.then((response) => response.json())
.then((cart) => this.renderCount(cart.item_count, false))
.catch(() => {});
};
renderCount(count, animate) {
if (!this.count) return;
this.count.textContent = String(count);
this.count.hidden = count === 0;
if (!animate || reducedMotion.matches) return;
this.count.classList.remove('is-bumped');
void this.count.offsetWidth;
this.count.classList.add('is-bumped');
}
}
const marquees = new Set();
let marqueeBoost = 0;
let marqueeFrame = 0;
let marqueeLast = 0;
let lastScrollY = window.scrollY;
window.addEventListener(
'scroll',
() => {
const y = window.scrollY;
marqueeBoost = Math.min(1, marqueeBoost + Math.abs(y - lastScrollY) / 120);
lastScrollY = y;
},
{ passive: true }
);
function marqueeTick(now) {
const dt = Math.min(0.05, (now - marqueeLast) / 1000);
marqueeLast = now;
marqueeBoost *= Math.pow(0.04, dt);
marquees.forEach((marquee) => marquee.step(dt, marqueeBoost));
marqueeFrame = marquees.size ? requestAnimationFrame(marqueeTick) : 0;
}
class SwMarquee extends HTMLElement {
connectedCallback() {
this.track = this.querySelector('.sw-marquee__track');
this.direction = this.dataset.direction === 'right' ? 'right' : 'left';
this.speed = parseFloat(this.dataset.speed || '40.66');
this.x = 0;
if (reducedMotion.matches || !this.track) return;
this.observer = new IntersectionObserver(([entry]) => {
if (entry.isIntersecting) this.start();
else marquees.delete(this);
});
this.observer.observe(this);
}
disconnectedCallback() {
this.observer?.disconnect();
marquees.delete(this);
}
start() {
marquees.add(this);
if (!marqueeFrame) {
marqueeLast = performance.now();
marqueeFrame = requestAnimationFrame(marqueeTick);
}
}
step(dt, boost) {
const half = this.track.scrollWidth / 2;
if (!half) return;
this.x = (this.x + (this.speed + 146.25 * Math.min(1, boost)) * dt) % half;
const offset = this.direction === 'right' ? this.x - half : -this.x;
this.track.style.transform = `translate3d(${offset}px,0,0)`;
}
}
class SwScrollRow extends HTMLElement {
connectedCallback() {
this.row = this.querySelector('.sw-row');
this.dots = this.querySelector('.sw-dots');
if (!this.row) return;
this.row.addEventListener('scroll', this.update, { passive: true });
this.resizeObserver = new ResizeObserver(this.update);
this.resizeObserver.observe(this.row);
this.enableDrag();
this.update();
}
disconnectedCallback() {
this.resizeObserver?.disconnect();
window.removeEventListener('pointermove', this.onPointerMove);
window.removeEventListener('pointerup', this.onPointerUp);
}
update = () => {
if (!this.dots) return;
const { scrollWidth, clientWidth, scrollLeft } = this.row;
const max = scrollWidth - clientWidth;
const pages = max > 2 ? Math.max(2, Math.ceil(scrollWidth / clientWidth)) : 0;
if (this.dots.childElementCount !== pages) {
this.dots.replaceChildren(...Array.from({ length: pages }, () => document.createElement('span')));
}
const active = pages ? Math.round((scrollLeft / max) * (pages - 1)) : -1;
[...this.dots.children].forEach((dot, index) => dot.classList.toggle('is-active', index === active));
};
enableDrag() {
this.row.dataset.drag = 'true';
this.moved = false;
this.row.addEventListener('pointerdown', (event) => {
if (event.pointerType !== 'mouse' || event.button !== 0) return;
this.dragging = true;
this.moved = false;
this.startX = event.clientX;
this.startLeft = this.row.scrollLeft;
this.row.classList.add('is-dragging');
window.addEventListener('pointermove', this.onPointerMove);
window.addEventListener('pointerup', this.onPointerUp);
});
this.row.addEventListener(
'click',
(event) => {
if (!this.moved) return;
event.preventDefault();
event.stopPropagation();
this.moved = false;
},
true
);
this.row.addEventListener('dragstart', (event) => event.preventDefault());
}
onPointerMove = (event) => {
if (!this.dragging) return;
const dx = event.clientX - this.startX;
if (Math.abs(dx) > 4) this.moved = true;
this.row.scrollLeft = this.startLeft - dx;
};
onPointerUp = () => {
this.dragging = false;
this.row.classList.remove('is-dragging');
window.removeEventListener('pointermove', this.onPointerMove);
window.removeEventListener('pointerup', this.onPointerUp);
};
}
let parallaxFrame = 0;
function updateParallax() {
parallaxFrame = 0;
const viewport = window.innerHeight;
document.querySelectorAll('[data-sw-parallax]').forEach((element) => {
const rect = element.getBoundingClientRect();
if (rect.bottom < -200 || rect.top > viewport + 200) return;
const progress = Math.min(1, Math.max(0, (viewport - rect.top) / (viewport + rect.height)));
element.style.backgroundPosition = `50% ${(progress * 100).toFixed(1)}%`;
});
}
function requestParallax() {
if (!parallaxFrame) parallaxFrame = requestAnimationFrame(updateParallax);
}
if (!reducedMotion.matches) {
window.addEventListener('scroll', requestParallax, { passive: true });
window.addEventListener('resize', requestParallax);
document.addEventListener('shopify:section:load', requestParallax);
requestParallax();
}
class SwAccordion extends HTMLElement {
connectedCallback() {
this.addEventListener('click', this.onClick);
}
disconnectedCallback() {
this.removeEventListener('click', this.onClick);
}
onClick = (event) => {
const button = event.target.closest('.sw-acc__btn');
if (!button || !this.contains(button)) return;
const willOpen = button.getAttribute('aria-expanded') !== 'true';
if (this.dataset.single !== 'false') {
this.querySelectorAll('.sw-acc__btn[aria-expanded="true"]').forEach((other) => other.setAttribute('aria-expanded', 'false'));
}
button.setAttribute('aria-expanded', String(willOpen));
};
}
class SwTrust extends HTMLElement {
connectedCallback() {
this.panel = this.querySelector('.sw-trust__panel');
this.panelTitle = this.querySelector('.sw-trust__panel-title');
this.panelText = this.querySelector('.sw-trust__panel-text');
this.addEventListener('click', this.onClick);
}
disconnectedCallback() {
this.removeEventListener('click', this.onClick);
}
onClick = (event) => {
if (event.target.closest('[data-sw-trust-close]')) {
this.close();
return;
}
const item = event.target.closest('.sw-trust__item');
if (!item || !this.contains(item)) return;
if (item.getAttribute('aria-expanded') === 'true') {
this.close();
return;
}
this.querySelectorAll('.sw-trust__item').forEach((other) => other.setAttribute('aria-expanded', 'false'));
item.setAttribute('aria-expanded', 'true');
const detail = item.querySelector('.sw-trust__detail');
this.panelTitle.textContent = item.querySelector('.sw-trust__title')?.textContent ?? '';
this.panelText.innerHTML = detail?.innerHTML ?? '';
this.panel.hidden = false;
this.panel.style.animation = 'none';
void this.panel.offsetWidth;
this.panel.style.animation = '';
};
close() {
this.querySelectorAll('.sw-trust__item').forEach((item) => item.setAttribute('aria-expanded', 'false'));
this.panel.hidden = true;
}
}
const SPARKS = [
[-4, 20, 10, '#fff'],
[8, -14, 7, 'var(--swush-purple-200)'],
[30, 112, 8, '#fff'],
[52, -10, 6, 'var(--swush-purple-300)'],
[76, 118, 9, 'var(--swush-purple-200)'],
[96, -6, 7, '#fff'],
[104, 80, 6, 'var(--swush-purple-300)'],
];
class SwFooter extends HTMLElement {
connectedCallback() {
this.policies = this.querySelector('.sw-footer__policies');
this.policiesButton = this.querySelector('.sw-footer__policies-btn');
this.policiesMenu = this.querySelector('.sw-footer__policies-menu');
this.logo = this.querySelector('.sw-footer__logo');
this.fx = this.querySelector('.sw-footer__fx');
this.mode = this.dataset.logoFx || 'iskrice';
this.canHover = window.matchMedia('(hover: hover)').matches;
if (this.policies) {
this.policiesButton.addEventListener('click', this.togglePolicies);
if (this.canHover) {
this.policies.addEventListener('pointerenter', this.openPolicies);
this.policies.addEventListener('pointerleave', this.closePoliciesSoon);
}
document.addEventListener('click', this.onDocumentClick);
this.policies.addEventListener('keydown', this.onKeydown);
}
if (this.logo && this.fx) {
this.logo.addEventListener('pointerenter', this.fire);
this.logo.addEventListener('click', this.onLogoClick);
}
}
disconnectedCallback() {
document.removeEventListener('click', this.onDocumentClick);
clearTimeout(this.policiesTimer);
clearTimeout(this.bounceTimer);
}
openPolicies = () => {
clearTimeout(this.policiesTimer);
this.policiesMenu.hidden = false;
this.policiesButton.setAttribute('aria-expanded', 'true');
};
closePolicies = () => {
clearTimeout(this.policiesTimer);
this.policiesMenu.hidden = true;
this.policiesButton.setAttribute('aria-expanded', 'false');
};
closePoliciesSoon = () => {
clearTimeout(this.policiesTimer);
this.policiesTimer = setTimeout(this.closePolicies, 180);
};
togglePolicies = () => (this.policiesMenu.hidden ? this.openPolicies() : this.closePolicies());
onDocumentClick = (event) => {
if (!this.policiesMenu.hidden && !this.policies.contains(event.target)) this.closePolicies();
};
onKeydown = (event) => {
if (event.key === 'Escape') {
this.closePolicies();
this.policiesButton.focus();
}
};
onLogoClick = (event) => {
if (this.logo.getAttribute('href') === window.location.pathname) event.preventDefault();
this.fire();
};
fire = () => {
if (reducedMotion.matches) return;
const mode = this.mode;
const layers = [];
if (mode === 'sjaj' || mode === 'odskok' || mode === 'sve') {
const shine = document.createElement('span');
shine.className = 'sw-footer__shine';
const src = this.logo.querySelector('img')?.currentSrc;
if (src) {
shine.style.webkitMaskImage = `url("${src}")`;
shine.style.maskImage = `url("${src}")`;
}
layers.push(shine);
}
if (mode === 'iskrice' || mode === 'sve') {
SPARKS.forEach(([x, y, size, color], index) => {
const spark = document.createElement('span');
spark.className = 'sw-footer__spark';
spark.style.cssText = `left:${x}%;top:${y}%;width:${size}px;height:${size}px;background:${color};animation-delay:${index * 60}ms`;
layers.push(spark);
});
}
this.fx.replaceChildren(...layers);
if (mode === 'odskok' || mode === 'sve') {
this.logo.classList.add('is-bouncing');
clearTimeout(this.bounceTimer);
this.bounceTimer = setTimeout(() => this.logo.classList.remove('is-bouncing'), 380);
}
};
}
const DAY_NAMES = ['nedelju', 'ponedeljak', 'utorak', 'sredu', 'četvrtak', 'petak', 'subotu'];
const WEEKDAY_INDEX = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
class SwCountdown extends HTMLElement {
connectedCallback() {
this.kicker = this.querySelector('.sw-countdown__kicker');
this.line = this.querySelector('.sw-countdown__line');
this.cutoff = parseInt(this.dataset.cutoff || '15', 10);
this.shipDays = (this.dataset.shipDays || '1,2,3,4,5').split(',').map(Number);
this.timeZone = this.dataset.timeZone || 'Europe/Belgrade';
this.render();
this.timer = setInterval(() => this.render(), 30000);
}
disconnectedCallback() {
clearInterval(this.timer);
}
now() {
const parts = Object.fromEntries(
new Intl.DateTimeFormat('en-US', {
timeZone: this.timeZone,
weekday: 'short',
hour: 'numeric',
minute: 'numeric',
hourCycle: 'h23',
})
.formatToParts(new Date())
.map(({ type, value }) => [type, value])
);
return { day: WEEKDAY_INDEX[parts.weekday], minutes: parseInt(parts.hour, 10) * 60 + parseInt(parts.minute, 10) };
}
render() {
const { day, minutes } = this.now();
const cutoffMinutes = this.cutoff * 60;
if (this.shipDays.includes(day) && minutes < cutoffMinutes) {
const left = cutoffMinutes - minutes;
const hours = Math.floor(left / 60);
const mins = left % 60;
const time = hours ? `${hours}h ${mins}min` : `${mins}min`;
this.kicker.textContent = this.dataset.kickerOpen;
this.line.textContent = this.dataset.lineOpen.replace('[vreme]', time);
return;
}
let offset = 1;
while (offset < 8 && !this.shipDays.includes((day + offset) % 7)) offset++;
const dayLabel = offset === 1 ? this.dataset.tomorrow || 'sutra' : `u ${DAY_NAMES[(day + offset) % 7]}`;
this.kicker.textContent = this.dataset.kickerClosed;
this.line.textContent = this.dataset.lineClosed.replaceAll('[dan]', dayLabel).replace('[sat]', String(this.cutoff));
}
}
class SwShipOptions extends HTMLElement {
connectedCallback() {
this.info = this.querySelector('.sw-ship__info');
this.infoTitle = this.querySelector('.sw-ship__info-title');
this.infoBody = this.querySelector('.sw-ship__info-body');
this.arrow = this.querySelector('.sw-ship__arrow');
this.grid = this.querySelector('.sw-ship__grid');
this.addEventListener('click', this.onClick);
}
disconnectedCallback() {
this.removeEventListener('click', this.onClick);
}
onClick = (event) => {
if (event.target.closest('[data-sw-ship-close]')) {
this.info.hidden = true;
return;
}
const option = event.target.closest('.sw-ship__opt');
if (!option) return;
this.querySelectorAll('.sw-ship__opt').forEach((other) => other.setAttribute('aria-pressed', String(other === option)));
const detail = option.querySelector('.sw-ship__detail');
this.infoTitle.textContent = detail?.dataset.title || option.querySelector('.sw-ship__name')?.textContent || '';
this.infoBody.innerHTML = detail?.innerHTML ?? '';
this.info.setAttribute('aria-label', option.querySelector('.sw-ship__name')?.textContent ?? '');
this.info.hidden = !detail || !detail.innerHTML.trim();
if (this.arrow && this.grid) {
const gridRect = this.grid.getBoundingClientRect();
const rect = option.getBoundingClientRect();
this.arrow.style.setProperty('--sw-arrow', `${rect.left - gridRect.left + rect.width / 2 - 7}px`);
}
};
}
const elements = {
'sw-header': SwHeader,
'sw-marquee': SwMarquee,
'sw-scroll-row': SwScrollRow,
'sw-accordion': SwAccordion,
'sw-trust': SwTrust,
'sw-footer': SwFooter,
'sw-countdown': SwCountdown,
'sw-ship-options': SwShipOptions,
};
Object.entries(elements).forEach(([name, element]) => {
if (!customElements.get(name)) customElements.define(name, element);
});
